import { t } from 'translations'

export const STATUS = [
    {
        name: 'OPEN',
        value: 'OPEN',
    },
    {
        name: 'MAINTENANCE',
        value: 'MAINTENANCE',
    },
    {
        name: 'CLOSED',
        value: 'CLOSED',
    },
]

export const getStatusLabel = (status: string): string => {
    switch (status) {
        case 'OPEN':
            return t('venue.parkMap.categoriesAndPois.status.open')
        case 'MAINTENANCE':
            return t('venue.parkMap.categoriesAndPois.status.maintenance')
        case 'CLOSED':
            return t('venue.parkMap.categoriesAndPois.status.closed')
        default:
            return status
    }
}
